export const DASHBOARD_WIDGETS = [
  { id: 'profile', label: 'Contexto do perfil' },
  { id: 'orgkpis', label: 'Indicadores do órgão' },
  { id: 'stats', label: 'Indicadores de licenças' },
  { id: 'consultationkpis', label: 'Consulta consolidada' },
  { id: 'analystkpis', label: 'Indicadores da fila' },
  { id: 'complaintkpis', label: 'Indicadores de denúncias' },
  { id: 'inspectionkpis', label: 'Indicadores de fiscalização' },
  { id: 'portfoliokpis', label: 'Indicadores de carteira' },
  { id: 'workqueues', label: 'Filas de trabalho' },
  { id: 'fieldprogress', label: 'Ação de campo' },
  { id: 'pendingdispatches', label: 'Tarefas e despachos' },
  { id: 'analystqueue', label: 'Fila do analista' },
  { id: 'complaintmix', label: 'Categorias de denúncia' },
  { id: 'recentcomplaints', label: 'Denúncias recentes' },
  { id: 'inspectionqueue', label: 'Vistorias agendadas' },
  { id: 'teamperformance', label: 'Desempenho da equipe' },
  { id: 'monitored', label: 'Empreendimentos monitorados' },
  { id: 'insights', label: 'Gestão' },
  { id: 'charts', label: 'Gráficos de licenças' },
  { id: 'activity', label: 'Atividade recente' },
  { id: 'notifications', label: 'Notificações' },
  { id: 'map', label: 'Mapa' },
];

export const PROFILE_PRESETS = {
  gestor: [
    'profile',
    'orgkpis',
    'stats',
    'fieldprogress',
    'pendingdispatches',
    'workqueues',
    'insights',
    'charts',
    'monitored',
    'map',
    'notifications',
  ],
  analista: ['profile', 'analystkpis', 'analystqueue', 'workqueues', 'charts', 'activity', 'notifications'],
  consulta: ['profile', 'consultationkpis', 'charts', 'monitored', 'map'],
  denuncias: ['profile', 'complaintkpis', 'complaintmix', 'recentcomplaints', 'insights', 'notifications'],
  fiscal: ['profile', 'inspectionkpis', 'inspectionqueue', 'fieldprogress', 'map', 'workqueues', 'notifications'],
  coordenador: ['profile', 'portfoliokpis', 'teamperformance', 'workqueues', 'insights', 'charts'],
  consultor: ['profile', 'analystkpis', 'analystqueue', 'workqueues', 'activity', 'notifications'],
  requerente: ['profile', 'stats', 'activity', 'map'],
};

function storageKey(userId) {
  return `useambiental.dashboard.layout.${userId || 'anon'}`;
}

export function resolveDashboardProfile(user) {
  const roles = (user?.roles || []).map((r) => String(r).toLowerCase());
  if (roles.includes('empresa') || roles.includes('empreendimento') || roles.includes('requerente')) {
    return 'requerente';
  }
  if (roles.includes('denuncias')) return 'denuncias';
  if (roles.includes('fiscal')) return 'fiscal';
  if (roles.includes('consulta')) return 'consulta';
  if (roles.includes('consultor')) return 'consultor';
  if (roles.includes('analista')) return 'analista';
  if (roles.includes('coordenador')) return 'coordenador';
  if (
    roles.includes('gestor_ambiental') ||
    roles.includes('tenant_admin') ||
    roles.includes('super_admin')
  ) {
    return 'gestor';
  }
  return 'gestor';
}

export function loadDashboardLayout(userId, profile) {
  const preset = PROFILE_PRESETS[profile] || PROFILE_PRESETS.gestor;
  try {
    const raw = localStorage.getItem(storageKey(userId));
    if (!raw) return { profile, order: preset, hidden: [] };
    const parsed = JSON.parse(raw);
    if (parsed.profile !== profile) return { profile, order: preset, hidden: [] };
    const order = Array.isArray(parsed.order)
      ? parsed.order.filter((id) => DASHBOARD_WIDGETS.some((w) => w.id === id))
      : preset;
    const missing = preset.filter((id) => !order.includes(id));
    return {
      profile,
      order: [...order, ...missing],
      hidden: Array.isArray(parsed.hidden) ? parsed.hidden : [],
    };
  } catch {
    return { profile, order: preset, hidden: [] };
  }
}

export function saveDashboardLayout(userId, layout) {
  localStorage.setItem(storageKey(userId), JSON.stringify(layout));
}

export function visibleWidgets(layout) {
  const hidden = new Set(layout.hidden || []);
  return (layout.order || []).filter((id) => !hidden.has(id));
}
